export const REMOVE_MESSAGE = 'remove-message';
